import React from 'react';

import { graphql, useLazyLoadQuery } from 'react-relay';

import { UserInlinePreview } from '@atlassian/user-inline-preview';

import type { peopleEntityInlineRelayQuery } from './__generated__/peopleEntityInlineRelayQuery.graphql';

type PeopleEntityInlineRelayProps = {
	accountId: string;
	cloudId: string;
};

/**
 * Loads fields required for `UserInlinePreview` via Relay.
 */
export function PeopleEntityInlineRelay({ accountId, cloudId }: PeopleEntityInlineRelayProps) {
	const accountIdARI = `ari:cloud:identity::user/${accountId}`;

	const data = useLazyLoadQuery<peopleEntityInlineRelayQuery>(
		graphql`
			query peopleEntityInlineRelayQuery($accountIdARI: ID!) {
				user(accountId: $accountIdARI) {
					accountId
					name
					picture
					... on AtlassianAccountUser {
						email
						extendedProfile {
							jobTitle
						}
					}
				}
			}
		`,
		{ accountIdARI },
	);

	const u = data.user;
	if (!u?.accountId) {
		return null;
	}

	const extended =
		'extendedProfile' in u
			? (u as {
					email?: string | null;
					extendedProfile?: { jobTitle?: string | null } | null;
				})
			: null;

	return (
		<UserInlinePreview
			data={{
				accountId: u.accountId,
				name: u.name ?? '',
				avatarUrl: u.picture ?? null,
				jobTitle: extended?.extendedProfile?.jobTitle ?? null,
				email: extended?.email ?? null,
			}}
			cloudId={cloudId}
			testId="lumina-people-entity-inline"
		/>
	);
}
